import React, { useEffect, useState } from "react";
import { FaEye, FaPlus } from "react-icons/fa6";
import Modal from "../../Modal/Modal";
import CreateRoleModal from "../../Modal/RolesModal/CreateRoleModal";
import { IoIosArrowBack } from "react-icons/io";
import ReactPaginate from "react-paginate";
import { IoCheckmark } from "react-icons/io5";
import { RxCross1, RxCross2 } from "react-icons/rx";
import { CiFilter } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoleAction,
  updateRoleAction,
} from "../../Actions/RoleAction/RoleAction";
import LoadingPage from "../Loading/LoadingPage";
import { useNavigate } from "react-router-dom";
import Pagination from "../Pagination";
import { FaEdit } from "react-icons/fa";
import { GrUpdate } from "react-icons/gr";

const RolePage = () => {
  const naviage = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [indexx, setIndexx] = useState(null);
  const [filter, setFilter] = useState({ name: "" });
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const getRole = useSelector((state) => state.getRole);
  const { roles, total, loading } = getRole;
  const createRole = useSelector((state) => state.createRole);
  const { loading: createLoading } = createRole;
  const dispatch = useDispatch();
  const [isOpenUpdate, setIsOpenUpdate] = useState(null);
  useEffect(() => {
    dispatch(getRoleAction(page, perPage, filter.name));
  }, [createLoading]);
  const handleSearch = () => {};
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };
  const onPageChange = () => {};
  const th = [
    {
      label: "Name",
      name: "name",
    },
  ];

  const [updateState, setUpdateState] = useState({
    id: "",
    name: "",
  });
  const handleUpdate = () => {
    if (updateState.name == "") {
      return;
    } else {
      dispatch(updateRoleAction(updateState.id, updateState.name));
      setIsOpenUpdate(null);
    }
  };
  const handleClose = () => {
    setIsOpenUpdate(null);
  };

  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="parent">
          <div className="flex justify-between items-center p-2">
            <div>
              <p className="font-bold">Roles</p>
            </div>
            <div>
              <button
                onClick={() => setIsOpenModal(true)}
                className="btn-primary flex gap-2 items-center "
              >
                Add Role
                <p>
                  <FaPlus />
                </p>
              </button>
            </div>
          </div>

          <div className={"parent-table  w-full"}>
            <div className=" overflow-y-auto" style={{ height: "70vh" }}>
              <table className="w-full  overflow-y-auto">
                <thead className="coustm-thead">
                  <tr>
                    <th className="coustm-th">#</th>
                    {th.map((th, index) => {
                      return (
                        <th className="coustm-th relative " key={index}>
                          <div className="flex justify-between items-center">
                            {th.label}
                            <div
                              className="parent-filter"
                              onClick={() => {
                                setIsOpenFilter(!isOpenFilter);
                                setIndexx(index);
                              }}
                            >
                              <CiFilter />
                            </div>
                          </div>
                          {index == indexx && isOpenFilter && (
                            <div className="parent-input-filter ">
                              <input
                                type="text"
                                className="p-2 text-black"
                                name={th.name}
                                onChange={handleFilterChange}
                                value={filter[th.name]}
                                placeholder={th.label}
                              />
                              <div className="fotter-filter mt-2">
                                <button
                                  className="btn-primary px-1.5 py-1 font-bold"
                                  onClick={handleSearch}
                                >
                                  <IoCheckmark />
                                </button>
                                <button className="btn-danger px-1.5 py-1">
                                  <RxCross2 />
                                </button>
                              </div>
                            </div>
                          )}
                        </th>
                      );
                    })}
                    {/* <th className="coustm-th">Visits </th> */}
                    <th className="coustm-th">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {roles?.map((role, index) => {
                    return (
                      <tr className={"coustm-tr"} key={index}>
                        <td className="coustm-td">{index + 1}</td>

                        {isOpenUpdate == index ? (
                          <td>
                            <input
                              type="text"
                              className="input w-full "
                              onChange={(e) => {
                                setUpdateState({
                                  ...updateState,
                                  name: e.target.value,
                                });
                              }}
                              value={updateState.name}
                            />
                          </td>
                        ) : (
                          <td className="coustm-td"> {role.name}</td>
                        )}
                        <td className="coustm-td w-72">
                          {" "}
                          {index == isOpenUpdate ? (
                            <div className="flex gap-2">
                              <button
                                className="btn-indigo group "
                                onClick={handleUpdate}
                              >
                                update
                                <p className=" duration-500 group-hover:rotate-180">
                                  <GrUpdate />
                                </p>
                              </button>
                              <button
                                onClick={handleClose}
                                className="btn-red group "
                              >
                                close
                                <p className=" duration-500 group-hover:rotate-180">
                                  <RxCross1 />
                                </p>
                              </button>
                            </div>
                          ) : (
                            <div className="flex justify-center gap-3">
                              <button
                                className="btn-blue "
                                onClick={() => {
                                  setIsOpenUpdate(index);
                                  setUpdateState({
                                    ...updateState,
                                    name: role.name,
                                    id: role.id,
                                  });
                                }}
                              >
                                Edit <FaEdit />
                              </button>
                              <button
                                onClick={() =>
                                  naviage("edit/" + role.id + "/" + role.name)
                                }
                                className="btn-indigo"
                              >
                                View <FaEye />
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <Pagination
            page={page}
            perPage={perPage}
            setPerPage={setPerPage}
            onPageChange={onPageChange}
            total={total}
          />
          {isOpenModal && (
            <Modal
              isOpen={isOpenModal}
              width={"w-3/12"}
              closeModal={() => setIsOpenModal(false)}
            >
              <CreateRoleModal closeModal={() => setIsOpenModal(false)} />
            </Modal>
          )}
        </div>
      )}
    </>
  );
};

export default RolePage;
